const topicTags = [
  { name: '院线热映', hot: true },
  { name: '高分神剧', hot: true },
  { name: '国产好片', hot: false },
  { name: '韩剧精选', hot: true },
  { name: '美剧排行', hot: false },
  { name: '日剧经典', hot: false },
  { name: '纪录片', hot: false },
  { name: '青春校园', hot: true },
  { name: '犯罪悬疑', hot: false },
  { name: '喜剧合集', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            全网影视热搜话题，看看大家都在追什么
          </p>
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          {topicTags.map((tag, i) => (
            <a
              key={i}
              href="#media"
              className={`inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                tag.hot
                  ? 'bg-primary-500 text-white hover:bg-primary-600'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200'
              }`}
            >
              {tag.name}
              {tag.hot && (
                <span className="flex items-center">
                  <i className="ri-fire-line text-xs"></i>
                </span>
              )}
            </a>
          ))}
        </div>
        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {[
            { label: '今日热搜', value: '#盗墓笔记之重启', trend: 'up' },
            { label: '飙升最快', value: '#长相思第二季', trend: 'up' },
            { label: '口碑推荐', value: '#繁花', trend: 'stable' },
            { label: '本周新剧', value: '#玫瑰的故事', trend: 'up' },
            { label: '经典重温', value: '#甄嬛传', trend: 'stable' },
          ].map((item, i) => (
            <div key={i} className="bg-background-100 rounded-xl p-4 cursor-pointer hover:bg-background-200 transition-colors">
              <div className="flex items-center justify-between mb-2">
                <span className="text-xs text-foreground-400">{item.label}</span>
                {item.trend === 'up' ? (
                  <i className="ri-arrow-up-line text-accent-500 text-sm"></i>
                ) : (
                  <i className="ri-subtract-line text-foreground-400 text-sm"></i>
                )}
              </div>
              <span className="text-sm font-semibold text-foreground-800">{item.value}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}